import React, { useRef, useState, useEffect, useMemo } from "react";

import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';
import {
    Box,
    Tooltip
} from '@mui/material';
import Skeleton from '@material-ui/lab/Skeleton';
import EditIcon from '@mui/icons-material/Edit';
//Icons Imports
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Stack from '@mui/material/Stack';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

import UpcomingIcon from '@mui/icons-material/Upcoming';


import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';

import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import Paper from '@mui/material/Paper';

import {
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

import HomeIcon from '@mui/icons-material/Home';
import BuildIcon from '@mui/icons-material/Build';
import GroupIcon from '@mui/icons-material/Group';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import ReactApexChart from 'react-apexcharts';

import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@material-ui/core/IconButton';
import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";
import moment from 'moment';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PostAddIcon from '@mui/icons-material/PostAdd';

import { parseISO } from 'date-fns';

import PaymentIcon from '@mui/icons-material/Payment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import HandshakeIcon from '@mui/icons-material/Handshake';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BusinessIcon from '@mui/icons-material/Business';
import CategoryIcon from '@mui/icons-material/Category';

import { Card, CardContent, Typography } from '@mui/material';
import { ArrowUpward, ArrowDownward, MoreVert, AttachMoney, ShoppingBasket } from '@mui/icons-material';

import { Button } from "@material-ui/core";

import DashboardLancamento from './dashboardLancamentos.js';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import MoneyOffIcon from '@mui/icons-material/MoneyOff';

import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';




const styles = {
    card: {
        borderRadius: '12px',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '200px',
    },
    purpleCard: {
        backgroundColor: '#6a1b9a',
        color: '#fff',
    },
    blueCard: {
        backgroundColor: '#0288d1',
        color: '#fff',
    },
    iconBox: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    iconBackground: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        padding: '8px',
    },
    graphBox: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderRadius: '8px',
        height: '40px',
        marginTop: '8px',
    },

};


export default function Lancamentos({ titulo, flag }) {


    function novo() {
        window.location.href = "/gestao/financas/lancamento/cadastrar"

    }



    const [loading, setLoading] = useState(true);

    const [objetos, setObjetos] = useState(null);

    const dataAtual = new Date();
    const mesAtual = dataAtual.toLocaleString('default', { month: 'long' });
    const anoAtual = dataAtual.getFullYear();

    const [totalRegistros, setTotalRegistros] = useState(0);

    const [filtro, setFiltro] = useState('');



    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });



    const [openDashboardLancamento, setOpenDashboardLancamento] = useState(false);

    const handleOpenDashboardLancamento = () => {
        setOpenDashboardLancamento(true);
    };

    const closeDashboardLancamento = () => {
        setOpenDashboardLancamento(false);
    };


    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 1000,
    });

    const [estatisticas, setEstatisticas] = useState({
        numDespesas: 0,
        numReceitas: 0,
        valorTotalDespesa: 0,
        valorTotalReceita: 0,
        valorTotalDespesaPaga: 0,
        valorTotalReceitaPaga: 0,
        valorTotalDespesaAPagar: 0,
        valorTotalReceitaAPagar: 0,
        valorTotalDespesaVencida: 0,
        valorTotalDespesaVenceHoje: 0,
        valorTotalDespesaAVencer: 0,
        valorTotalReceitaVencida: 0,
        valorTotalReceitaVenceHoje: 0,
        valorTotalReceitaAVencer: 0,
    });

    function calcularEstatisticas(filteredRows) {
        const dataHoje = moment().format('YYYY-MM-DD');

        const stats = filteredRows.reduce(
            (acc, lancamento) => {
                try {
                    const valor = Number(lancamento.valor) || 0;
                    const valorPago = Number(lancamento.valor_pago_concluido) || 0;
                    const valorRestante = valor - valorPago;
                    const valorAVencer =  Number(lancamento.valor_total_a_vencer) || 0;

                    let dataVencimento = null;
                    if (lancamento.data_proximo_vencimento) {
                        const m = moment(lancamento.data_proximo_vencimento);
                        if (m.isValid()) {
                            dataVencimento = m.format('YYYY-MM-DD');
                        }
                    }

                    const valorVencimento = Number(lancamento.valor_proximo_vencimento) || 0;

                    if (lancamento.tipo === 0) {
                        // Despesas
                        acc.numDespesas += 1;
                        acc.valorTotalDespesa += valor;
                        acc.valorTotalDespesaPaga += valorPago;
                        acc.valorTotalDespesaAPagar += valorRestante;
                        acc.valorTotalDespesaAVencer += valorAVencer;

                        if (dataVencimento) {
                            if (dataVencimento < dataHoje) {
                                acc.valorTotalDespesaVencida += valorVencimento;
                            } else if (dataVencimento === dataHoje) {
                                acc.valorTotalDespesaVenceHoje += valorVencimento;
                            } 
                        }
                    } else if (lancamento.tipo === 1) {
                        // Receitas
                        acc.numReceitas += 1;
                        acc.valorTotalReceita += valor;
                        acc.valorTotalReceitaPaga += valorPago;
                        acc.valorTotalReceitaAPagar += valorRestante;
                        acc.valorTotalReceitaAVencer += valorAVencer;

                        if (dataVencimento) {
                            if (dataVencimento < dataHoje) {
                                acc.valorTotalReceitaVencida += valorVencimento;
                            } else if (dataVencimento === dataHoje) {
                                acc.valorTotalReceitaVenceHoje += valorVencimento;
                            }
                        }
                    }
                } catch (error) {
                    console.error("Erro ao calcular estatísticas para lançamento:", lancamento, error);
                }
                return acc;
            },
            {
                numDespesas: 0,
                numReceitas: 0,
                valorTotalDespesa: 0,
                valorTotalReceita: 0,
                valorTotalDespesaPaga: 0,
                valorTotalReceitaPaga: 0,
                valorTotalDespesaAPagar: 0,
                valorTotalReceitaAPagar: 0,
 
                valorTotalDespesaVencida: 0,
                valorTotalDespesaVenceHoje: 0,
                valorTotalReceitaVencida: 0,
                valorTotalReceitaVenceHoje: 0,

                    valorTotalDespesaAVencer: 0,
                    valorTotalReceitaAVencer: 0,
            }
        );

      
        // arredonda
        const rounded = Object.fromEntries(
            Object.entries(stats).map(([k, v]) =>
                k.startsWith('valor') ? [k, Math.round((v + Number.EPSILON) * 100) / 100] : [k, v]
            )
        );

        setEstatisticas(rounded);
    }


    async function listarLancamentos() {

        setLoading(true);

        try {
            const token = Cookies.get('token');
            const id_usuario = Cookies.get('id_usuario');

            const headers = {
                'Authorization': 'Bearer ' + token
            }

            const regra = Cookies.get('regra');
            if (regra.includes("ADMIN")) {


                let response2 = await api.get(`v1/protected/financeiro/lancamentos/listartodossimples?tipo=${flag}&busca=${filtro}&size=${pagination.pageSize}&page=${pagination.pageIndex}`, { headers });

                setObjetos(response2.data.dados); // você deve retornar os dados paginados como { dados: [...], total: X }


                calcularEstatisticas(response2.data.dados);

                setTotalRegistros(response2.data.total);
                setLoading(false);

            }

        } catch (_err) {

            console.log("Erro ao listar objetos: " + _err)
            setLoading(false);

        }

    }






    useEffect(() => {
        listarLancamentos();
    }, [pagination]); // <-- refaz a requisição ao mudar página ou tamanho




    const columns = useMemo(
        () => [

            {
                accessorKey: 'id_lancamento',
                header: 'ID',
                size: 30,
                accessorFn: row => row.id_lancamento, // garante que filtro funcione
                Cell: ({ cell }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {cell.getValue()}
                    </span>
                ),
            },
             {
                            accessorKey: 'tipo',
                            header: 'Tipo',
                            size: 30,
                            accessorFn: row => row.tipo === 0 ? 'Despesa' : 'Receita', // usado para exibição e filtro
                            Cell: ({ row }) => (
                                <span style={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {row.original.tipo === 0 ? 'Despesa' : 'Receita'}
                                </span>
                            ),
                        },
            {
                header: 'Identificador',
                size: 150,
                accessorKey: 'identificador', // pega direto da propriedade identificador
                Cell: ({ cell }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        🆔 {cell.getValue() || '-'}
                    </span>
                ),
            },
            {
                header: 'Conta',
                size: 200,
                maxHeight: 200,
                accessorFn: row => ({ nome: row.conta || '', grupo: row.grupo_conta || '' }),
                filterFn: (row, id, filterValue) => {
                    const { nome, grupo } = row.getValue(id);
                    const search = filterValue.toLowerCase();
                    return nome.toLowerCase().includes(search) || grupo.toLowerCase().includes(search);
                },
                Cell: ({ cell }) => {
                    const { nome, grupo } = cell.getValue();
                    return (
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <AccountBalanceIcon fontSize="small" color="secondary" />
                            {grupo && nome ? `${grupo} - ${nome}` : nome || grupo}
                        </span>
                    );
                },
            },
            {
                header: 'Fornecedor',
                size: 300,
                maxHeight: 300,
                accessorKey: 'fornecedor', // usar accessorKey direto facilita filtros e ordenação
                Cell: ({ cell }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <BusinessIcon fontSize="small" color="primary" />
                        {cell.getValue()}
                    </span>
                ),
            },

            {
                accessorKey: 'valores',
                header: 'Valores',
                size: 200,
                Cell: ({ row }) => {
                    const valor = row.original.valor || 0;
                    const valorPago = row.original.valor_pago_concluido || 0;
                    const valorRestante = valor - valorPago;

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                            <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <AttachMoneyIcon fontSize="small" color="primary" />
                                Total: {currencyFormatter.format(valor)}
                            </span>
                            <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <AttachMoneyIcon fontSize="small" color="success" />
                                Pago: {currencyFormatter.format(valorPago)}
                            </span>
                            <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                <AttachMoneyIcon fontSize="small" color="error" />
                                Restante: {currencyFormatter.format(valorRestante)}
                            </span>
                        </div>
                    );
                },
                Footer: ({ table }) => {
                    const total = table.getRowModel().rows.reduce(
                        (acc, row) => {
                            const valor = row.original.valor || 0;
                            const valorPago = row.original.valor_pago_concluido || 0;
                            const valorRestante = valor - valorPago;

                            acc.valorTotal += valor;
                            acc.valorPagoTotal += valorPago;
                            acc.valorRestanteTotal += valorRestante;

                            return acc;
                        },
                        { valorTotal: 0, valorPagoTotal: 0, valorRestanteTotal: 0 }
                    );

                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, fontWeight: 'bold', fontSize: '16px' }}>
                            <span
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 4,
                                    fontWeight: 'bold',
                                    fontSize: '22px', // aumenta o tamanho da fonte
                                }}
                            >
                                <AttachMoneyIcon fontSize="small" color="primary" />
                                Total: {currencyFormatter.format(total.valorTotal)}
                            </span>
                            <span
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 4,
                                    fontWeight: 'bold',
                                    fontSize: '22px', // aumenta o tamanho da fonte
                                }}
                            >
                                <AttachMoneyIcon fontSize="small" color="success" />
                                Pago: {currencyFormatter.format(total.valorPagoTotal)}
                            </span>
                            <span
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 4,
                                    fontWeight: 'bold',
                                    fontSize: '22px', // aumenta o tamanho da fonte
                                }}
                            >
                                <AttachMoneyIcon fontSize="small" color="error" />
                                Restante: {currencyFormatter.format(total.valorRestanteTotal)}
                            </span>
                        </div>
                    );
                },
            },

            {
                accessorKey: 'data_proximo_vencimento',
                header: 'Data Prox. Venc.',
                size: 120,
                Cell: ({ cell }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        <HourglassBottomIcon fontSize="small" color="action" />
                        {cell.getValue() ? moment(cell.getValue()).format('DD/MM/YYYY') : '-'}
                    </span>
                ),
            },
            {
                accessorKey: 'valor_proximo_vencimento',
                header: 'Valor a Vencer',
                size: 120,
                Cell: ({ cell }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        <AttachMoneyIcon fontSize="small" color="warning" />
                        {cell.getValue() ? currencyFormatter.format(cell.getValue()) : '-'}
                    </span>
                ),
                Footer: ({ table }) => {
                    const total = table.getRowModel().rows.reduce((sum, row) => {
                        const value = row.getValue('valor_proximo_vencimento');
                        return sum + (value ? Number(value) : 0);
                    }, 0);

                    return (
                        <span
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 4,
                                fontWeight: 'bold',
                                fontSize: '22px', // aumenta o tamanho da fonte
                            }}
                        >
                            <AttachMoneyIcon fontSize="small" color="warning" />
                            {currencyFormatter.format(total)}
                        </span>
                    );
                },
            },

            flag === 2 && {
                accessorKey: 'tipo',
                header: 'Tipo',
                size: 130,
                accessorFn: row => {
                    switch (row.tipo) {
                        case 0: return 'DESPESA';
                        case 1: return 'RECEITA';
                        case 2: return 'EMPRÉSTIMO';
                        case 3: return 'TRANSFERÊNCIA';
                        default: return '';
                    }
                },
                Cell: ({ cell }) => {
                    const value = cell.getValue(); // agora vem como string (ex: "DESPESA")

                    if (value === 'DESPESA')
                        return <><PaymentIcon color="error" fontSize="small" /> {value}</>;
                    if (value === 'RECEITA')
                        return <><AttachMoneyIcon color="success" fontSize="small" /> {value}</>;
                    if (value === 'EMPRÉSTIMO')
                        return <><HandshakeIcon color="primary" fontSize="small" /> {value}</>;
                    if (value === 'TRANSFERÊNCIA')
                        return <><SwapHorizIcon color="warning" fontSize="small" /> {value}</>;

                    return null;
                },
            },
            {
                accessorKey: 'status',
                header: 'Status',
                size: 130,
                accessorFn: row => {
                    if (row.status === 0) return 'NÃO PAGO';
                    if (row.status === 1) return 'PAGO';
                    return '';
                },
                Cell: ({ cell }) => {
                    const value = cell.getValue(); // agora vem "NÃO PAGO" ou "PAGO"

                    if (value === 'NÃO PAGO')
                        return <><CancelIcon color="error" fontSize="small" /> {value}</>;
                    if (value === 'PAGO')
                        return <><CheckCircleIcon color="success" fontSize="small" /> {value}</>;

                    return null;
                },
            },

            {
                accessorKey: 'centro_custo',
                header: 'Centro de Custo',
                size: 150,
                maxHeight: 150,
                Cell: ({ renderedCellValue }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <CategoryIcon fontSize="small" color="action" />
                        {renderedCellValue}
                    </span>
                ),
            },

            {
                accessorKey: 'data_lancamento',
                header: 'Data',
                size: 130,
                accessorFn: row => row.data_lancamento, // valor bruto no formato ISO ou timestamp
                Cell: ({ cell }) => (
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <CalendarTodayIcon fontSize="small" color="action" />
                        {moment(cell.getValue()).format('DD/MM/YYYY')}
                    </span>
                ),
                filterVariant: 'range', // 🔹 ativa range de valores
                filterFn: (row, id, filterValue) => {
                    const cellValue = moment(row.getValue(id));
                    const [start, end] = filterValue || [];

                    if (start && cellValue.isBefore(moment(start), 'day')) return false;
                    if (end && cellValue.isAfter(moment(end), 'day')) return false;

                    return true;
                },
            },


        ].filter(Boolean),
        [],
    );

    function handleClickGerenciar(row) {
        const idLancamento = row.original.id_lancamento;
        const url = `/gestao/financas/lancamento/gerenciar/${idLancamento}`;
        window.location.href = url;
    }

const tableHeight = window.innerHeight - 200; // 300px é um exemplo do cabeçalho + filtros + padding

    const table = useMaterialReactTable({
        columns: columns,
        data: objetos,
        enableBottomToolbar: true,
        enableGlobalFilterModes: true,
        enableRowActions: true,
        manualPagination: true,
        onPaginationChange: setPagination,
        rowCount: totalRegistros,
        state: { pagination },
        enableStickyHeader: true,
        paginationDisplayMode: 'pages',
        getRowId: (row) => row.id_lancamento,
        enableGrouping: true,
        initialState: {
            showGlobalFilter: true,
            showColumnFilters: true,
            columnVisibility: {
                id_lancamento: false, // 🔹 começa oculta
            },
        },
          muiTableContainerProps: {
        sx: {
             maxHeight: 'calc(100vh - 370px)',
            overflowY: 'auto',      // habilita scroll interno se precisar
        },
    },
      
        muiPaginationProps: {
            rowsPerPageOptions: [1000, 2000, 3000],
            variant: 'outlined',
        },
        enableFullScreenToggle: true,
        renderDetailPanel: ({ row }) => (
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'space-around',
                    left: '30px',
                    maxWidth: '1000px',
                    position: 'sticky',
                    width: '100%',
                }}
            >
                {/* conteúdo do painel detalhado */}
            </Box>
        ),
        renderRowActions: ({ row }) => (
            <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'row', alignItems: 'center' }}>
                <Tooltip title="Gerenciar">
                    <IconButton color="error" onClick={() => handleClickGerenciar(row)}>
                        <SettingsIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        ),
        muiTableHeadCellProps: {
            sx: { fontSize: '0.8rem', padding: '6px 8px' },
        },
        muiTableBodyCellProps: {
            sx: { fontSize: '0.75rem', padding: '2px 6px' },
        },
        muiTableBodyRowProps: { sx: { minHeight: '24px' } },
        localization: MRT_Localization_PT_BR,

        // Callback para atualizar estatísticas sempre que filtros ou estado mudarem
        onStateChange: () => {
            if (!table || !table.getFilteredRowModel()) return;

            const filteredRows = table.getFilteredRowModel().rows.map(row => row.original);
            calcularEstatisticas(filteredRows);
        },
    });





    return (

        <div>
            <Box
                sx={{
                    mb: 3,
                    display: "flex",
                    flexDirection: "column",
                    pl: 2,
                    pr: 2,
                    gap: 2, // espaçamento entre título/botão e estatísticas
                }}
            >
                {/* Cabeçalho */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <ReceiptLongIcon color="primary" />
                        <Typography
                            variant="h6"
                            component="h1"
                            fontWeight="bold"
                            color="primary"
                        >
                            {titulo}
                        </Typography>

                        {/* Botão de dashboard */}
                        <IconButton
                            color="primary"
                            onClick={handleOpenDashboardLancamento}
                            sx={{ ml: 1 }}
                        >
                            <DashboardIcon />
                        </IconButton>
                    </Box>

                    <Button variant="contained" color="primary" onClick={novo} sx={{ ml: 2 }}>
                        Novo Lançamento
                    </Button>
                </Box>


                <Grid container spacing={1}>


                    {(flag === 2 || flag === 0) &&
                        <Grid item xs={6} container>


                            <Grid item xs={12}>
                                <Stack direction="row" spacing={1}>
                                    <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                        <MoneyOffIcon color="error" sx={{ fontSize: 14 }} />
                                        <Typography variant="caption" fontWeight="bold">
                                            {estatisticas?.numDespesas || 0} Despesas
                                        </Typography>
                                    </Paper>
                                    <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                        <TrendingDownIcon color="error" sx={{ fontSize: 14 }} />
                                        <Typography variant="caption" fontWeight="bold">
                                            Total: {currencyFormatter.format(estatisticas.valorTotalDespesa)}
                                        </Typography>
                                    </Paper>
                                    <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                        <CheckCircleIcon color="error" sx={{ fontSize: 14 }} />
                                        <Typography variant="caption" fontWeight="bold">
                                            Total Pago: {currencyFormatter.format(estatisticas.valorTotalDespesaPaga)}
                                        </Typography>
                                    </Paper>
                                    <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                        <HourglassBottomIcon color="error" sx={{ fontSize: 14 }} />
                                        <Typography variant="caption" fontWeight="bold">
                                            Total a Pagar: {currencyFormatter.format(estatisticas.valorTotalDespesaAPagar)}
                                        </Typography>
                                    </Paper>
                                </Stack>
                            </Grid>

                            <Grid item xs={12}>
                                <Stack direction="row" spacing={1}>
                                    <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                        <EventBusyIcon color="error" sx={{ fontSize: 14 }} />
                                        <Typography variant="caption" fontWeight="bold">
                                            Vencido: {currencyFormatter.format(estatisticas.valorTotalDespesaVencida)}
                                        </Typography>
                                    </Paper>

                                    <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                        <EventAvailableIcon color="warning" sx={{ fontSize: 14 }} />
                                        <Typography variant="caption" fontWeight="bold">
                                            Vencendo Hoje: {currencyFormatter.format(estatisticas.valorTotalDespesaVenceHoje)}
                                        </Typography>
                                    </Paper>

                                    <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                        <UpcomingIcon color="success" sx={{ fontSize: 14 }} />
                                        <Typography variant="caption" fontWeight="bold">
                                            Vence Futuro: {currencyFormatter.format(estatisticas.valorTotalDespesaAVencer)}
                                        </Typography>
                                    </Paper>
                                </Stack>
                            </Grid>

                        </Grid>
                    }


                    {(flag === 2 || flag === 1) &&
                        <Grid item xs={6} container>

                            <Grid item xs={12}>
                                <Stack direction="row" spacing={1}>
                                    <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                        <AttachMoneyIcon color="success" sx={{ fontSize: 14 }} />
                                        <Typography variant="caption" fontWeight="bold">
                                            {estatisticas?.numReceitas || 0} Receitas
                                        </Typography>
                                    </Paper>
                                    <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                        <TrendingUpIcon color="success" sx={{ fontSize: 14 }} />
                                        <Typography variant="caption" fontWeight="bold">
                                            Total: {currencyFormatter.format(estatisticas.valorTotalReceita)}
                                        </Typography>
                                    </Paper>
                                    <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                        <CheckCircleIcon color="success" sx={{ fontSize: 14 }} />
                                        <Typography variant="caption" fontWeight="bold">
                                            Total Recebido: {currencyFormatter.format(estatisticas.valorTotalReceitaPaga)}
                                        </Typography>
                                    </Paper>
                                    <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                        <HourglassBottomIcon color="success" sx={{ fontSize: 14 }} />
                                        <Typography variant="caption" fontWeight="bold">
                                            Total a Receber: {currencyFormatter.format(estatisticas.valorTotalReceitaAPagar)}
                                        </Typography>
                                    </Paper>
                                </Stack>
                            </Grid>

                            <Grid item xs={12}>
                                <Stack direction="row" spacing={1}>
                                    <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                        <EventBusyIcon color="error" sx={{ fontSize: 14 }} />
                                        <Typography variant="caption" fontWeight="bold">
                                            Vencido: {currencyFormatter.format(estatisticas.valorTotalReceitaVencida)}
                                        </Typography>
                                    </Paper>

                                    <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                        <EventAvailableIcon color="warning" sx={{ fontSize: 14 }} />
                                        <Typography variant="caption" fontWeight="bold">
                                            Vencendo Hoje: {currencyFormatter.format(estatisticas.valorTotalReceitaVenceHoje)}
                                        </Typography>
                                    </Paper>

                                    <Paper elevation={1} sx={{ p: 0.5, display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                        <UpcomingIcon color="success" sx={{ fontSize: 14 }} />
                                        <Typography variant="caption" fontWeight="bold">
                                            Vence Futuro: {currencyFormatter.format(estatisticas.valorTotalReceitaAVencer)}
                                        </Typography>
                                    </Paper>
                                </Stack>
                            </Grid>

                        </Grid>
                    }
                </Grid>

            </Box>

            {loading ?
                <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                </Skeleton>
                :

                <div>
                   <div style={{ backgroundColor: 'white', height: tableHeight }}>
                        {objetos !== null && (
                            <>

                                <MaterialReactTable table={table} />
                            </>
                        )}
                    </div>
                </div>
            }



            <Dialog open={openDashboardLancamento} onClose={closeDashboardLancamento} PaperProps={{ style: { maxWidth: '1400px', minWidth: '1200px' } }}>
                <DialogContent>
                    <DashboardLancamento flag={flag} />
                </DialogContent>
            </Dialog>


        </div>


    );
}



